import type { Book } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import booksService from "@/features/books/services/booksService";
import DURATIONS from "@/shared/constants/durations";
import { booksKeys } from "./booksQueryKeys";

/**
 * Fetches all books from Firestore
 * Uses 1 day staleTime for caching
 * @returns Query result with all books
 */
export function useBooks() {
    return useQuery<Book[], Error>({
        gcTime: DURATIONS.ONE_DAY,
        queryFn: () => booksService.getAllBooks(),
        queryKey: booksKeys.list(),
        staleTime: DURATIONS.ONE_DAY,
    });
}
